module.exports = __webpack_public_path__ + "static/img/02042D_3_4_C_20240426_fit.d10e48f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02042D_3_4_C_20240426_fit.png
// module id = y+M+
// module chunks = 0